/**
 * Adds 'is-single' class to <figure> if a row contains only one figure.
 * Target: `.block-media-standard__row` elements.
 */
const customClass = () => {
	const rows = document.querySelectorAll('.block-media-standard__row');

	rows.forEach((row) => {
		const figures = row.querySelectorAll('figure');
		if (figures.length === 1) {
			figures[0].classList.add('is-single');
		}
	});
};

export default customClass;
